var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tab",class:{ 'tab--active': _vm.isActive },attrs:{"id":_vm.name,"disabled":_vm.disabled,"aria-selected":_vm.isActive},on:{"click":function($event){return _vm.selectTab()}}},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }